import { render, staticRenderFns } from "./seaBookingBasic.vue?vue&type=template&id=3b06dc9a&scoped=true&"
import script from "./seaBookingBasic.vue?vue&type=script&lang=js&"
export * from "./seaBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingBasic.vue?vue&type=style&index=0&id=3b06dc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06dc9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b06dc9a')) {
      api.createRecord('3b06dc9a', component.options)
    } else {
      api.reload('3b06dc9a', component.options)
    }
    module.hot.accept("./seaBookingBasic.vue?vue&type=template&id=3b06dc9a&scoped=true&", function () {
      api.rerender('3b06dc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingBasic.vue"
export default component.exports